import { SchoolReportsUIProvider } from "./SchoolReportsUIContext";
import { SchoolReportsCard } from "./SchoolReportsCard";

export function SchoolReportsPage({ history }) {
  const schoolReportsUIEvents = {
    openNewSchoolReportPage: () => {
      history.push("/ogrenci-okul-karneleri/ekle");
    },
    openEditSchoolReportPage: (id) => {
      history.push(`/ogrenci-okul-karneleri/duzenle/${id}`);
    },
  };
  
  return (
    <SchoolReportsUIProvider schoolReportsUIEvents={schoolReportsUIEvents}>
      <SchoolReportsCard />
    </SchoolReportsUIProvider>
 );
}